export default "__VITE_ASSET__BOtvagGV__"